import { Injectable } from '@angular/core';
import { ServiceService } from './service.service'

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor( private servi: ServiceService ) { }

  userAuthentication(userName, password) {
    const data = { Username: userName, Password: encodeURIComponent(password) };
    return this.servi.post_p('Login/Authenticate', data );
  }

  roleMatch(allowedRoles): boolean {

    const userRoles: string[] = localStorage.getItem('userRoles')  ? JSON.parse( localStorage.getItem('userRoles') ) : [];

    let sw = false;

    allowedRoles.forEach(element => {
      if (userRoles.indexOf(element) > -1) { sw = true; return; }
    });

    return sw;
  }

  isLogin() {
    const token = encodeURIComponent(this.servi.getToken() || '-1')  ;
    return this.servi.post_p('Login/ValidateToken' , {token : token} );
  }


}
